"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatus = exports.BILLING_CYCLE = void 0;
exports.BILLING_CYCLE = {
    YEAR: 'year',
    MONTH: 'month',
    WEEK: 'week',
    DAY: 'day'
};
exports.SubscriptionStatus = {
    ACTIVE: 'active',
    TRIALING: 'trialing',
    INCOMPLETE: 'incomplete',
    INCOMPLETE_EXPIRED: 'incomplete_expired',
    UNPAID: 'unpaid',
    PAST_DUE: 'past_due',
    CANCELED: 'canceled'
};
//# sourceMappingURL=moments.js.map